import React from "react";
import { arrayOf, bool, node, string } from "prop-types";
import { floorPlanShape } from "../../common/floorPlan.js";
import Card from "../Card/Card.jsx";
import Results from "../Results/Results.jsx";
import ResultsHeader from "../Results/ResultsHeader.jsx";
import { ListIcon } from "../../common/icons.jsx";

const propTypes = {
  isLoading: bool,
  floorPlans: arrayOf(floorPlanShape).isRequired,
  pagination: node,
  resultsRange: node,
  title: string,
};

const FloorPlanList = props => {
  const { isLoading, floorPlans, pagination, resultsRange, title } = props;
  return (
    <div className="floor-plan-list">
      <Results
        isLoading={isLoading}
        header={<ResultsHeader title={title} resultsRange={resultsRange} />}
        pagination={pagination}
      >
        {floorPlans.length === 0 && !isLoading
          ? "No results, try changing some filters above."
          : floorPlans.map(floorPlanData => {
              const {
                id,
                area,
                bathrooms,
                bedrooms,
                floorPlan,
                attributes,
                image,
                matterportId,
                selfguidedTour,
                startingAt,
                unitsAvailable,
                url,
              } = floorPlanData;

              return (
                <Card
                  key={id}
                  detailUrl={url}
                  detailButton={
                    <React.Fragment>
                      <ListIcon /> {unitsAvailable} home
                      {unitsAvailable !== 1 && "s"}
                    </React.Fragment>
                  }
                  title={floorPlan}
                  image={<img src={image} alt={`Floorplan ${floorPlan}`} />}
                  matterportId={matterportId}
                  selfguidedTour={selfguidedTour}
                  stats={[
                    `${area} Sq. Ft.`,
                    bedrooms,
                    bathrooms,
                    `Starting at ${startingAt}`,
                    (attributes && `Features: ${attributes.join(", ")}`)
                  ]}
                />
              );
            })}
      </Results>
    </div>
  );
};

FloorPlanList.propTypes = propTypes;
export default FloorPlanList;
